export const ERROR_CODE = {
    EmailAlreadyRegistered: 'EMAIL_ALREADY_REGISTERED',
    CardRegistrationError: 'CARD_REGISTRATION_ERROR',
    InvalidCredentials: 'INVALID_CREDENTIALS',
    InvalidToken: 'INVALID_TOKEN',
    NoEmailVerifyWaiting: 'NO_EMAIL_VERIFY_WAITING',
    PhoneAlreadyRegistered: 'PHONE_ALREADY_REGISTERED'
};
